var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechMicroscope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neutral_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M387.1,422.8H362c7.8-3.4,14.1-9.5,17.6-17.4c3.7-8.4,3.9-17.7,0.6-26.2c-3.3-8.6-9.7-15.3-18-19 c-8.3-3.7-17.6-4-26.1-0.6L246.7,394c-7.2,2.9-17.2-1.8-24.7-8.6c6.7-10.2,10.6-22.4,10.6-35.4c0-4.2-0.4-8.2-1.2-12.2 l117.2-48.3c4.6-1.9,6.9-7.2,4.9-11.9c-1.9-4.7-7.2-6.9-11.8-5l-116.3,47.9c-9.5-18.5-27.5-31.7-48.8-34.5L158,238.4 c-5-12.4,1-26.6,13.4-31.7l4.6-1.9l13.8,33.3c0.1,0.6,0.3,1.2,0.5,1.8l9,22c0.9,2.2,2.6,4,4.8,4.9l26,11.2 c1.1,0.5,2.4,0.7,3.6,0.7c1.1,0,2.3-0.2,3.4-0.6l37-14.9c2.2-0.9,4-2.7,5-4.9l11.1-26.1c1-2.2,1-4.8,0.1-7l-9-22.1v0 c-0.1-0.6-0.3-1.2-0.5-1.8l-42-102.1c-2.5-6.3-4.3-10.9-9.5-13.1c-5.1-2.2-9.6-0.4-16.4,2.3l-1.5,0.6l-8.2-20.6l7.6-3.2 c3.3-1.4,5.9-4,7.2-7.3c1.3-3.3,1.3-6.9,0-10.2l-7.1-17.2c-2.9-6.7-10.7-9.9-17.4-7.1l-65,27c-6.7,2.8-10,10.6-7.2,17.5l7.1,17.1 c1.4,3.3,3.9,5.9,7.2,7.3c3.3,1.4,6.9,1.4,10.2,0l6.8-2.8l8,20.3l-1.6,0.7c-14.7,5.9-17,11.3-11,26.4l1.9,4.5l-4.1,1.6 c-47.2,19.3-70.1,73.6-51,121.1l20.6,49.5c-7,10.3-11.1,22.8-11.1,36.3c0,31,21.9,57,51,63.1c0.1,0.2,0.1,0.4,0.2,0.5 c1.2,2.1,3.2,5.4,5.6,9.2h-48.1c-14.4,0-26.1,12.3-26.1,27.3v18.2c0,5,4.1,9.1,9.1,9.1h308.2c5,0,9.1-4.1,9.1-9.1v-18.2 C413.1,435.1,401.4,422.8,387.1,422.8z M253.3,411l89.2-34.5c4-1.6,8.3-1.4,12.2,0.3c3.9,1.8,6.9,4.9,8.5,9 c1.5,4,1.4,8.4-0.3,12.3c-1.7,3.9-4.9,7-8.9,8.5L312,422.8H183.7c-2.1-2.4-4.4-5.4-6.8-9c12.5-1.7,23.9-6.9,33.1-14.8 C221.2,409.3,237.8,417.3,253.3,411z M271.9,228.6l-8.1,19.1l-30.1,12.1l-19.1-8.2l-4.1-10.1l57.3-23.1L271.9,228.6z  M220.1,105.2c0.4-0.2,0.8-0.3,1.2-0.5c0.2,0.6,0.5,1.1,0.7,1.7l39.1,95l-57.3,23.1l-39.1-94.7c-0.2-0.5-0.4-1.1-0.7-1.7 c0.6-0.2,1.2-0.5,1.8-0.7L220.1,105.2z M169.3,82.7l17-7.1l8.1,20.5l-17.1,7L169.3,82.7z M143.2,73.8l-3.4-8.2L196,42.2l3.4,8.2 L143.2,73.8z M111.5,257.3c-15.3-38.1,3.1-81.8,40.9-97.2l4.4-1.7L169,188l-4.5,1.8c-21.6,8.9-32.1,33.7-23.4,55.3l16.2,41.4 c-10.6,1.9-20.3,6.3-28.5,12.7L111.5,257.3z M123.9,350c0-24.7,20-44.8,44.6-44.8S213,325.3,213,350s-20,44.8-44.6,44.8 S123.9,374.7,123.9,350z M395,459.2H105v-9.1c0-5,3.6-9.1,7.9-9.1h274.2c4.4,0,7.9,4.1,7.9,9.1V459.2z"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechMicroscope;